import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom';
import { useStoreSubTypesByAdmin } from '../../../hooks/admin/storeType.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import EmptyData from '../../../components/ui/EmptyData';
import StoreSubTypesTable from '../../../components/admin/storeSybTypes/StoreSubTypesListTable';

function AdminViewStoreSubTypesPage() {
    const {t} = useTranslation();
    
  const { typeId} = useParams<{ typeId: string}>();
  const numericTypeIdId = typeId ? parseInt(typeId) : 0;
  const {data:subTypes,isLoading,isError} = useStoreSubTypesByAdmin(numericTypeIdId);
  return (
    <Layout title={t('sub_types')} headline=''>
        <div className='flex justify-end'>
            <PrimaryButtonWithIconAdd
            buttonLabel="add_new_sub_type"
            buttonLinkPath={`/admin/add-subType/${numericTypeIdId}`}
            />
         </div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
         {
        subTypes && (
          subTypes.length === 0 ?<EmptyData/> : <StoreSubTypesTable subTypes={subTypes}/>
        )
        }
    </Layout>
  )
}

export default AdminViewStoreSubTypesPage